import { apiFetch } from '@/lib/api-client';
import type {
  Series,
  SeriesEpisode,
  SeriesListEnvelope,
  SeriesPreviewResponse,
  GenerateEpisodeResponse,
  GenerateRemainingResponse,
  PreviewSeriesRequest,
  ConfirmSeriesRequest,
} from './types';

/** POST /series/preview — one Claude call → one season plan. Free. */
export function previewSeries(body: PreviewSeriesRequest): Promise<SeriesPreviewResponse> {
  return apiFetch<SeriesPreviewResponse>('/api/series/preview', { method: 'POST', body });
}

/** POST /series/:id/confirm — persist the plan's episodes + title. */
export function confirmSeries(seriesId: string, body: ConfirmSeriesRequest): Promise<Series> {
  return apiFetch<Series>(`/api/series/${seriesId}/confirm`, { method: 'POST', body });
}

/** GET /series — owner-scoped list. */
export function fetchSeriesList(): Promise<SeriesListEnvelope> {
  return apiFetch<SeriesListEnvelope>('/api/series');
}

/** GET /series/:id — detail incl. episodes. */
export function fetchSeriesById(seriesId: string): Promise<Series> {
  return apiFetch<Series>(`/api/series/${seriesId}`);
}

/** GET /series/:id/episodes/:n — single episode. */
export function fetchSeriesEpisode(
  seriesId: string,
  episodeNumber: number,
): Promise<SeriesEpisode> {
  return apiFetch<SeriesEpisode>(`/api/series/${seriesId}/episodes/${episodeNumber}`);
}

/** POST /series/:id/episodes/:n — generate a single episode (1 credit). */
export function generateSeriesEpisode(
  seriesId: string,
  episodeNumber: number,
): Promise<GenerateEpisodeResponse> {
  return apiFetch<GenerateEpisodeResponse>(`/api/series/${seriesId}/episodes/${episodeNumber}`, {
    method: 'POST',
  });
}

/** POST /series/:id/generate-remaining — batch-generate all remaining episodes. */
export function generateSeriesRemaining(seriesId: string): Promise<GenerateRemainingResponse> {
  return apiFetch<GenerateRemainingResponse>(`/api/series/${seriesId}/generate-remaining`, {
    method: 'POST',
  });
}

/** POST /series/:id/combine-audio — manually (re)start the Gesamt-Hörbuch combine. */
export function triggerCombineAudio(
  seriesId: string,
): Promise<{ seriesId: string; combinedAudioStatus: string }> {
  return apiFetch<{ seriesId: string; combinedAudioStatus: string }>(
    `/api/series/${seriesId}/combine-audio`,
    { method: 'POST' },
  );
}
